import { useEffect } from "react";
import { useWeb3Context } from "web3-react";
import { ethers } from "ethers";
import { useSnackbar } from "notistack";
export default function Web3ReactManager({ children }) {
  const { setConnector, error, active, unsetConnector } = useWeb3Context();
  const { enqueueSnackbar } = useSnackbar();

  // initialization management
  useEffect(() => {
    if (!active) {
      if (window.ethereum) {
        try {
          const library = new ethers.providers.Web3Provider(window.ethereum);
          library.listAccounts().then((accounts) => {
            if (accounts.length >= 1) {
              setConnector("Injected", { suppressAndThrowErrors: true });
            } else {
              setConnector("Network");
            }
          });
        } catch {
          setConnector("Network");
        }
      } else {
        setConnector("Network");
      }
    }
  }, [active, setConnector]);

  useEffect(() => {
    if (error) {
      unsetConnector();
      enqueueSnackbar(error.message, {
        variant: "info",
        autoHideDuration: 3000,
      });
    }
  }, [enqueueSnackbar, error, unsetConnector]);

  return children;
}
